<template>
  <v-app>
    <v-content>
      <TheHeader/>
      <Lange/>
      <ContactBTN/>
      <Situation/>
      <Wie/>
      <Kraft/>
      <AlleKraft/>
      <Ankommt/>
      <Name/>
      <Contact id="kontakt"/>
      <TheFooter/>
    </v-content>
  </v-app>
</template>

<script>
import TheHeader from './components/TheHeader'
import Lange from './components/Lange'
import Situation from './components/Situation'
import Wie from './components/Wie'
import Kraft from './components/Kraft'
import AlleKraft from './components/AlleKraft'
import Ankommt from './components/Ankommt'
import Name from './components/Name'
import Contact from './components/Contact'
import TheFooter from './components/TheFooter'
import ContactBTN from './components/ContactBTN'

export default {
  name: 'App',

  components: {
    TheHeader,
    Lange,
    Contact,
    TheFooter,
    Situation,
    Wie,
    Kraft,
    AlleKraft,
    Ankommt,
    Name,
    ContactBTN
  },

  data: () => ({
    //
  })
}
</script>

<style lang="scss">
  .theme--light.v-text-field > .v-input__control > .v-input__slot::before {
    border: 1px solid #F49E00 ;
  }

  .v-text-field > .v-input__control > .v-input__slot::after {
    border-color: #F49E00;
  }

  .theme--light.v-text-field:not(.v-input--has-state):hover > .v-input__control > .v-input__slot::before {
    border-color: #F49E00;
  }

  .v-application .primary--text {
    color: #F49E00 !important;
  }

  // Setting Max width for content
  .row {
    max-width: 1035px;
    margin: 0 auto;
    width: 100%;
  }

  // Setting max width for smaller rows
  .smaller-row-width {
    max-width: 850px;
    width: 100%;
  }

  // Setting Row Max width
  .max-row-790 {
    max-width: 790px;
    margin-left: 113px;
    width: 100%;
  }

  // Setting Max Content for 2 Layer Layout
  .max-650 {
    max-width: 650px;
    width: 100%;
  }

  // Setting Max Content for 2 Layer Layout inside a container
  .max-520 {
    max-width: 520px;
    width: 100%;
  }

  // Setting BG Image
  .einstieg {
    background-image: url('/images/RaabCoaching_gespiegelt.jpg');
    background-size: cover;
    background-position: top left;
  }

  .v-btn__content {
    flex-direction: column !important;
  }

  // Basic Global Element Setup
  h1 {
    font-family: $second-font-family;
    font-size: 2.5rem;
    font-weight: 500;
    font-style: normal;
    line-height: 1.16;
    color: $white;
    margin-left: 2em;
  }

  p {
    font-family: $body-font-family;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.56;
    letter-spacing: .18px;
    color: $white;

    &.text-yellow {
      font-family: $second-font-family;
      font-size: .944rem;
      font-weight: 700;
      line-height: 1.47;
      letter-spacing: .17px;
      color: $orange-yellow;
      max-width: 230px;
      float: right;
    }

    &.text-blue {
      font-family: $second-font-family;
      font-size: .944rem;
      font-weight: 700;
      line-height: 1.47;
      letter-spacing: .17px;
      color: $dark-grey-blue;
      max-width: 230px;
      float: right;
    }

    &.text-blue-light {
      font-family: $second-font-family;
      font-size: .944rem;
      font-weight: 700;
      line-height: 1.47;
      letter-spacing: .17px;
      color: $sapphire;
      max-width: 230px;
      float: right;
    }
  }

  hr {
    width: 167px;
    border: solid 2px $orange-yellow;
    margin-top: 2.9rem;
    margin-bottom: 1.28rem;
  }

  // Video BTN
  .start-button {
    &.button {
      .size-124 {
        font-size: 6.889rem;
      }
    }
  }

  // Video Container
  .vue-video-center {
    .title {
      line-height: 1.25rem;
    }
  }

  // Global Responsive
  @media screen and (max-width: 1263px) {
    .max-650 {
      max-width: 100%;
   }

   .smaller-row-width {
    max-width: 1035px;
   }

    p {
      &.text-yellow,
      &.text-blue,
      &.text-blue-light {
        float: left;
      }
    }
  }

  @media screen and (max-width: 959px) {
    .max-row-790 {
      max-width: 100%;
      margin-left: 0;
    }

    .max-520 {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 600px) {
    h1 {
      font-size: 1.56rem;
    }
      // Video BTN
    .start-button {
      &.button {
        .size-124 {
          font-size: 3rem;
        }
      }
    }
  }

  @media screen and (max-width: 375px) {
    // Video BTN
    .start-button {
      &.button {
        .size-124 {
          font-size: 2rem;
        }
      }
    }
  }
</style>
